// extracted by mini-css-extract-plugin
export default {"menuTitle":"MileageEtc_menuTitle__J9Rt8"};